module.exports = __webpack_public_path__ + "img/20_yeas_back.6025b6e9.svg";